import { atom } from "jotai";
import { CrewTracker } from "models";

/**
 * Atom which stores the crewTracker data (used for the map)
 */
export const crewTrackerAtom = atom<CrewTracker | undefined>(undefined);
